<template>
  <div class="coach-register-form">
    <a href="/"> <img src="images/logo.png" alt="Logo" class="text-center"/></a>
    <h2>Coach Verification Request Form</h2>
    <span class="required-field-text"
      >Fields marked with asterisk sign(*) are required fields</span
    >
    <div class="coach-verifcation-form">
      <a-form layout="horizontal" :form="form" @submit="handleSubmit">
        <div class="college-data">
          <a-form-item>
            <a-select
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              v-decorator="[
                'state',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Select State!'
                    }
                  ]
                }
              ]"
              placeholder="Select State *"
              @change="handleStateChange"
            >
              <a-select-option
                v-for="state in stateList"
                :key="state._id"
                :value="state._id"
                >{{ state.name }}</a-select-option
              >
            </a-select>
          </a-form-item>
          <a-form-item>
            <a-select
              show-search
              option-filter-prop="children"
              :filter-option="filterOption"
              v-decorator="[
                'CollegeId',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Select College!'
                    }
                  ]
                }
              ]"
              placeholder="Select College *"
              @change="handleCollegeChange"
            >
              <a-select-option
                v-for="college in collegeList"
                :key="college.id"
                :value="college.id"
                >{{ college.collegeName }}</a-select-option
              >
            </a-select>
          </a-form-item>
        </div>
        <div class="coach-data" v-bind:class="{ active: isCollegeActive }">
          <a-form-item>
            <a-input
              v-decorator="[
                'coachname',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your Full name!'
                    }
                  ]
                }
              ]"
              placeholder="Full Name *"
            >
              <a-icon
                slot="prefix"
                type="user"
                style="color: rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'email',
                {
                  rules: [
                    {
                      type: 'email',
                      message: 'The input is not valid E-mail!'
                    },
                    {
                      required: true,
                      message: 'Please input your E-mail!'
                    }
                  ]
                }
              ]"
              placeholder="Email Address *"
            >
              <a-icon slot="prefix" type="mail" style="color: rgba(0,0,0,.25)"
            /></a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'staffPhone',
                {
                  rules: [
                    {
                      required: false,
                      message: 'Please input your number!'
                    }
                  ]
                }
              ]"
              placeholder="Phone Number"
            >
              <a-icon
                slot="prefix"
                type="phone"
                style="color: rgba(0,0,0,.25)"
              />
            </a-input>
          </a-form-item>
          <a-form-item>
            <a-input
              v-decorator="[
                'position',
                {
                  rules: [
                    {
                      required: true,
                      message: 'Please input your position!'
                    }
                  ]
                }
              ]"
              placeholder="Position *"
            >
              <a-icon slot="prefix" type="audit" style="color: rgba(0,0,0,.25)"
            /></a-input>
          </a-form-item>
        </div>

        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            class="login-form-button next-button save-button width-100-rounded "
          >
            Send Verification Request
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { RepositoryFactory } from "../../repositories/RepositoryFactory";
const TaxonomyRepository = RepositoryFactory.get("taxonomy");
const CollegeRepository = RepositoryFactory.get("college");
const CoachRepository = RepositoryFactory.get("coach");

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some(field => fieldsError[field]);
}

export default {
  name: "CoachRegister",
  data() {
    return {
      stateList: [],
      collegeList: [],
      isCollegeActive: false,
      hasErrors,
      form: this.$form.createForm(this)
    };
  },
  mounted() {
    this.$nextTick(() => {
      // To disabled submit button at the beginning.
      // this.form.validateFields();
    });
  },
  created() {
    TaxonomyRepository.getSortedTaxonomyValues("College State").then(response => {
      this.stateList = response.data.taxonomy.values;
    });
  },
  methods: {
    handleStateChange(value) {
      this.collegeList = [];
      this.form.resetFields("CollegeId");
      CollegeRepository.getCollegeList(
        `forverify/collegelist?fields=collegeName&sort=collegeName&state=${value}`
      ).then(response => {
        this.collegeList = response.data.colleges;
      });
    },
    handleCollegeChange() {
      this.isCollegeActive = true;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    // Only show error after a field is touched.
    handleError(val) {
      const { getFieldError, isFieldTouched } = this.form;
      return isFieldTouched(val) && getFieldError(val);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          CoachRepository.registerCoach(values).then(response => {
            if (response.status === "error") {
              this.$notification.error({
                message: "Error",
                description: response.message
              });
            } else {
              this.$notification.success({
                message: "Success",
                description:
                  "Your detail has been sent for verification. We will let you know through your email."
              });
              this.form.resetFields();
              // this.form.validateFields();
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.card {
  h2 {
    margin-bottom: 10px !important;
  }
}
.coach-verifcation-form {
  margin-top: 40px;
  .coach-data {
    height: 0;
    opacity: 0;
    transition: all 0.2s linear;
    &.active {
      height: 270px;
      opacity: 1;
    }
  }
}
@media only screen and (max-width: 575px) {
  .coach-register-form {
    .ant-btn-primary {
      font-size: 12px;
      padding: 8px 30px;
      line-height: 20px;
      height: 100%;
      span {
        white-space: initial;
      }
    }
  }
}
</style>
